export default "__VITE_ASSET__12da4bc6__"